import { Button, EButtonColor, HeroSection, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ETagType, FirebaseSelectors, renderStringToReact, useTranslation } from '@web_opxp/features';
import { useDispatch, useSelector } from 'react-redux';
import { ASSESSMENT_SESSION_ID } from '../../base/constants';
import Env from '../../base/env';
import { CyclesSelectors } from '../../cycles';
import { AssessmentProgress, ProgressPageState } from '../AssessmentProgress';
import { AssessmentActions } from '../slice';
import { getAssessmentConfigForCycle, getAssessmentLength } from '../utils';

export default function CFQIntro() {
  const { t } = useTranslation();

  const cycleId = useSelector(CyclesSelectors.getCurrentCycleId);
  const firebaseReady = useSelector(FirebaseSelectors.isReady);
  const config = firebaseReady ? getAssessmentConfigForCycle(cycleId) : undefined;
  const sessionLength = getAssessmentLength(ASSESSMENT_SESSION_ID, config);
  const imageSrc = `${Env.AssetsBaseUrl}/feature/cfq/cfq_welcome.svg`;
  const dispatch = useDispatch();
  const startCFQ = () => dispatch(AssessmentActions.startCFQ());
  return (
    <>
      <HeroSection imgSrc={imageSrc}>
        <SectionTitle>{t('CFQ.Welcome.Title')}</SectionTitle>
        <SectionSubtitle wrapperTag="div">
          {renderStringToReact(t('CFQ.Welcome.SubtitleHtml'), ETagType.div)}
        </SectionSubtitle>
        <Button color={EButtonColor.white} label={t('CFQ.Welcome.CTA')} onClick={startCFQ} />
      </HeroSection>
      <Section>
        <AssessmentProgress
          page={ProgressPageState.AssessmentSession}
          max={sessionLength}
          step={sessionLength}
          cfq={true}
        />
      </Section>
    </>
  );
}
